<template>
  <v-col cols="12">
    <gg-card>
      <gg-card-header>
        Create Repository
      </gg-card-header>
      <gg-card-text>
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-switch v-model="clone"
                        label="Clone a Repository"
                        hint="Enable this toggle if you want to clone a remote repository, or disable this toggle to create a new repository. "
                        persistent-hint
              />
            </v-col>
            <v-col cols="12" v-if="clone">
              <gg-text-field label="Clone URL"
                             hint="Enter the clone URL for the remote repository. All clone URLs must begin with the http://, https://, ssh://, or git:// protocols or begin with a username and domain."
                             persistent-hint
                             v-model="model.cloneUrl"
                             v-validate="'required'"
                             name="clone-url"
                             data-vv-as="Clone url"
                             :error-messages="errors.collect('clone-url')"

              />
            </v-col>
            <v-col cols="12">
              <gg-text-field label="Repository Path"
                             hint="Enter the desired path for the repository’s directory. If you enter a path that does not exist, the system will create the directory when it creates or clones the repository. "
                             persistent-hint
                             :prefix="rootPath"
                             v-model="model.repository_path"
                             v-validate="'required'"
                             name="repository-path"
                             data-vv-as="Repository path"
                             :error-messages="errors.collect('repository-path')"
              />
            </v-col>
            <v-col cols="12">
              <gg-text-field label="Repository Name"
                             hint="This name does not impact functionality, and instead functions only as a display name. "
                             persistent-hint
                             v-model="model.name"
                             v-validate="'required'"
                             name="repository-name"
                             data-vv-as="Repository name"
                             :error-messages="errors.collect('repository-name')"
              />
            </v-col>

          </v-row>
        </v-form>
        <v-row>
          <v-col cols="12">
            <gg-btn :loading="loading" :disabled="loading" @click="createRepository">
              Create repository
            </gg-btn>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
  </v-col>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CreateRepository',
  data: () => ({
    clone: false,
    rootPath: '',
    model: {
      cloneUrl: '',
      name: '',
      repository_path: '',
      type: 'git'
    },
    loading: false,
  }),
  mounted () {
    this.getRootPath()
  },
  methods: {
    ...mapActions({
      getRepositories: 'hosting_git/getRepositories',
      getHostingSettings: 'hosting_git/getHostingSettings',
      createRepo: 'hosting_git/createRepo',
      reportError: 'reportError'
    }),
    async getRootPath () {
      try {
        const { data } = await this.getHostingSettings(this.$route.query.user)

        this.rootPath = `${data.home}/`
      } catch (e) {
        this.reportError(e)
      }
    },
    async createRepository () {
      try {
        const valid = await this.$validator.validateAll()

        if (!valid) { return }

        this.loading = true

        const source = {
          remote_name: 'origin',
          url: this.model.cloneUrl
        }

        await this.createRepo({
          name: this.model.name,
          repository_root: `${this.rootPath}${this.model.repository_path}`,
          type: 'git',
          source_repository: this.clone ? JSON.stringify(source) : undefined,
          _username: this.$route.query.user,
        })

        await this.getRepositories(this.$route.query.user)

        this.model.cloneUrl = ''
        this.model.name = ''
        this.model.repository_path = ''
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>

</style>
